import React from 'react'
import './ConfigCard.scss'

export default function ConfigCard(props) {
  const {title, description, children} = props;

  return (
    <div className='configCard'>
      <div className='configCardTitle'>{title}</div>
      {description && <div className='configCardDescription'>{description}</div>}
      <div className='configCardContent'>{children}</div>
    </div>
  )
}